<template>
  <details class="funding-bookings" :open="editable || undefined">
    <summary>Bookings ({{ bookings.length }})</summary>
    <div v-for="booking in bookings" :key="booking.client_group_id" class="funding-bookings__row">
      <div>
        <fieldset v-if="editable" class="funding-bookings__selection" :disabled="disabled || (!retained && booking.availability !== 'available')">
          <app-checkbox v-model="booking.selected" :label="groupName(booking.group)" />
        </fieldset>
        <strong v-else>{{ groupName(booking.group) }}</strong>
        <div>Contract: {{ booking.contract }} · Participants: {{ booking.participants_count }}</div>
        <div>Individual: {{ formatAmount(booking.individual_fees_amount) }} · Shared: {{ formatAmount(booking.shared_fees_amount) }} USD</div>
        <div>Need: {{ formatAmount(booking.funding_base) }} · Confirmed: {{ formatAmount(booking.confirmed_funding_amount) }} · Reserved: {{ formatAmount(booking.reserved_funding_amount) }} USD</div>
        <div>Remaining: {{ formatAmount(booking.remaining_funding_amount) }} · Available: {{ formatAmount(booking.available_funding_amount) }} USD</div>
        <div v-if="booking.coverage">Coverage: paid {{ formatAmount(booking.coverage.paid_amount_usd) }}, committed {{ formatAmount(booking.coverage.committed_usd) }}, reserved {{ formatAmount(booking.coverage.reserved_usd) }}, free {{ formatAmount(booking.coverage.free_usd) }} USD</div>
        <div v-if="booking.unavailable_reason" class="funding-bookings__reason">{{ availabilityReason(booking) }}</div>
        <div v-if="booking.active_draft_batch_id">Reserved in draft #{{ booking.active_draft_batch_id }}</div>
      </div>
      <app-form-group v-if="editable && booking.selected" label="Selected amount (USD)" :label-for="inputPrefix + '-' + booking.client_group_id" class="form-group--no-indent">
        <app-input :id="inputPrefix + '-' + booking.client_group_id" v-model="booking.amount_usd" inputmode="decimal" :disabled="disabled" :error="!!bookingAmountError(booking, retained)" />
        <template v-if="bookingAmountError(booking, retained)" #error>{{ bookingAmountError(booking, retained) }}</template>
      </app-form-group>
      <strong v-else-if="booking.amount_usd">Selected: {{ formatAmount(booking.amount_usd, 'USD') }}</strong>
    </div>
  </details>
</template>

<script>
import { availabilityReason, bookingAmountError, formatAmount, groupName } from './funding'

export default {
  name: 'FundingBookings',
  props: {
    bookings: { type: Array, required: true },
    editable: Boolean,
    retained: Boolean,
    disabled: Boolean,
    inputPrefix: { type: String, default: 'booking-amount' },
  },
  methods: { availabilityReason, bookingAmountError, formatAmount, groupName },
}
</script>

<style lang="sass" scoped>
.funding-bookings
  margin-top: 10px
  min-width: 280px
  white-space: normal
  text-align: left
  line-height: 1.5

  summary
    cursor: pointer
    font-weight: 500

.funding-bookings__row
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  align-items: center
  gap: 12px
  padding: 12px 0
  font-size: 12px
  border-bottom: 1px solid $color-border

.funding-bookings__selection
  border: 0
  padding: 0
  margin: 0
  min-width: 0

  &:disabled
    opacity: .65

.funding-bookings__reason
  color: #a15c00
</style>
